import type {
	CitiesResponseSchema,
	CitySchema,
	CountriesResponseSchema,
	DeleteAccountBodySchema,
	DeleteAccountResponseSchema,
	EmailLoginBodySchema,
	LoginEmailVerifyBodySchema,
	LoginPhoneVerifyBodySchema,
	LoginResponseSchema,
	LoginVerifyResponseSchema,
	PhoneLoginBodySchema,
	ProfileBodySchema,
	StateSchema,
	StatesResponseSchema,
	UserInfoResponseSchema,
	UserSchema,
	ZipCodesResponseSchema,
} from "src/schema/auth-schema";
import type { z } from "zod";

export type TPhoneLoginBody = z.infer<typeof PhoneLoginBodySchema>;
export type TEmailLoginBody = z.infer<typeof EmailLoginBodySchema>;
export type TLoginResponse = z.infer<typeof LoginResponseSchema>;
export type TDeleteAccountBody = z.infer<typeof DeleteAccountBodySchema>;
export type TDeleteAccountResponse = z.infer<typeof DeleteAccountResponseSchema>;

export type TLoginPhoneVerifyBody = z.infer<typeof LoginPhoneVerifyBodySchema>;
export type TLoginEmailVerifyBody = z.infer<typeof LoginEmailVerifyBodySchema>;
export type TLoginVerifyResponse = z.infer<typeof LoginVerifyResponseSchema>;

export type TMe = z.infer<typeof UserSchema>;
export type TUserInfoResponse = z.infer<typeof UserInfoResponseSchema>;

export type TZipCodeResponse = z.infer<typeof ZipCodesResponseSchema>;

export type TCountryCodeResponse = z.infer<typeof CountriesResponseSchema>;
//City
export type TCity = z.infer<typeof CitySchema>;
export type TCitiesResponse = z.infer<typeof CitiesResponseSchema>;
//State
export type TState = z.infer<typeof StateSchema>;
export type TStatesResponse = z.infer<typeof StatesResponseSchema>;
//Profile
export type TProfileBody = z.infer<typeof ProfileBodySchema>;

//Constants
// User_Type_CHOICES Enum
export enum UserTypeChoices {
	ChoiceNoSelect = 0,
	ChoiceDriver = 1,
	ChoiceOperator = 2,
	ChoiceCarrier = 3,
	ChoiceSelfCarrier = 4,
	ChoiceManager = 5,
	ChoiceShipper = 6,
	ChoiceBroker = 7,
	ChoiceAdmin = 8,
}

// User_Status_CHOICES Enum
export enum UserStatusChoices {
	ChoiceUnknown = 0,
	ChoiceCompletedProfile = 1,
	ChoiceSelectCarrier = 2,
	ChoiceAddDriver = 3,
	ChoiceAddTruck = 4,
	ChoiceCreateTrip = 5,
	ChoiceCompleteSteps = 6,
}
